// extracted by mini-css-extract-plugin
export default {"blogs":"blogs_blogs__Uqsfb","cta-button":"blogs_cta-button__JzE-4"};